import * as marietta3d from '..';

export default class RoomEstimate {
    public estimate: Array<marietta3d.AutoGen.EstimateValue>;

    constructor() {
      this.estimate = [];
    }
}
